import React, { useState, useEffect,} from "react";
import { Col, Modal, Nav, Row, Tab, Image, Button, InputGroup, Form } from "react-bootstrap";
import Card from "../../../components/card/AdminCard";
import LearningModulesEdit from "./LearningModulesEdit";
import LearningModulesModal from "../modal/LearningModulesModal";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { GetLearningModule,selectLearningModule } from "../../../features/learning/learningModuleSlice";
import { GetCounsellorModule,selectCounsellorModule } from "../../../features/learning/CounsellorSlice";
import Edit from '../../../assets/images/ic-edit.svg';
import Add from '../../../assets/images/ic-add.svg';
import Search from '../../../assets/images/search-line.svg';
import Back from '../../../assets/images/ic-arrow-back.svg';
import Dots from "../../../assets/images/la-dots.svg";
import LearningModules from "../sections/LearningModules";
import SearchBar from "../../../components/searchbar/SearchBar";
import EmptyRow from "../../../components/emptyRow/EmptyRow";
import Feedback from "../../../components/feedbackNote/Feedback";

const title: String = "";
const title2: String = "";

const EthicsCounsellorEditDetails = () => {
  const LearingModule = useAppSelector(selectLearningModule);
  const CounsellorModule = useAppSelector(selectCounsellorModule);
  const dispatch = useAppDispatch();
  //console.log('LearingModule',LearingModule)
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  useEffect(() => {
    var data={
      keyword:"",
      offset:0,
      companyId:userDetailsJson.companyId
    }
    async function fetchLearningModuleData() {      
      let sample = await dispatch(GetLearningModule(data));     
    }
    
    async function fetchConsellerModuleData() {      
      let sample = await dispatch(GetCounsellorModule(data));     
    }
    fetchLearningModuleData();
    fetchConsellerModuleData();
  }, []);
  const [searchData, setsearchData]=useState('')
  const searchItems=async(searchValue:any)=>{
    await setsearchData(searchValue)
    var data={
      keyword:searchData,
      offset:0,
      companyId:userDetailsJson.companyId
    }
    await dispatch(GetLearningModule(data))
    await dispatch(GetCounsellorModule(data))
}

   const rowLearnArrayData=LearingModule?.slice(0, 4)
   const Learnlist:any = rowLearnArrayData;

   const rowConsellArrayData=CounsellorModule?.slice(0, 4)
   const consellList:any = rowConsellArrayData;
   const fetchLearningModuleData=()=> {    
    var data={
      keyword:"",
      offset:0,
      companyId:userDetailsJson.companyId
    }  
     dispatch(GetCounsellorModule(data));     
  }
  return (
    <>
    <Feedback pageName="Learning And Awarness"/>
    <Row>
      <Col sm={12}>
      <a href="/ethicscounsellorDetails">
        <span style={styles.backstyle}><Image src={Back} />Back </span>
      </a>  
      </Col>
    </Row>
    <EmptyRow/>
   
    <Row>
        <Col sm={8}>
        <h4>Ethics Counsellor Learning Program</h4>
        </Col>

        <Col sm={4}>
        <InputGroup className="border bg-white" style={{border: "solid 1px #e4e4e4",}}>
                <Image style={styles.image1} className="d-inline border-0 my-auto mx-2" src={Search} fluid />
                <Form.Control onChange={(e) => searchItems(e.target.value)} name={searchData} className="border-0 shadow-none ps-0" style={styles.text1} type="text" placeholder="Search" />
            </InputGroup>
        </Col>
    </Row>    

    <EmptyRow/>

    
      
    <div style={{ marginBottom: "20px" }}>     
   
         <Card
          type={2}
          title={title2}
          data={CounsellorModule}
          fetchLearningModuleData={fetchLearningModuleData}
          moduleid={2}
        //   modal={
        //     <>
        //       <LearningModulesModal  title="Ethics Counsellor Programs" records={CounsellorModule} />
        //       <LearningModulesEdit title="Edit Ethics Counsellors Program" data={CounsellorModule}/>
        //     </>
         // }
        /> 
      </div>

      
    </>
  );
};

const styles: any = {
 
    editstyle: {
        color: "#e31837",
        fontFamily: "Saira",
        fontWeight: 600,
        fontSize: "12px",
        float:"right",
        marginTop:"10px",
        
    },

    backstyle: {
      color: "#e31837",
      fontFamily: "Saira",
      fontWeight: 600,
      fontSize: "12px",
      marginTop:"10px",
      
  },
};

export default EthicsCounsellorEditDetails;
